import React from 'react';
import './SubscriptionCard.less';
import { EquipmentInfo } from 'app/components/access-sharing';
import { dummyEquipmentData } from 'app/constants/access-sharing';
import { useTranslation } from 'react-i18next';
import { BaseButton } from 'app/components/buttons/BaseButton';
import { Button } from '@progress/kendo-react-buttons';
import { Subscription } from 'app/pages/ManageSubscriptionPlansPage/type';
import clsx from 'clsx';
import { SubscriptionPlanBadge } from 'app/pages/ManageSubscriptionPlansPage/components';
import { useManageYourPlanDialog } from 'context';

interface Props {
  subscription: Subscription;
  isLast: boolean;
}

export default function SubscriptionCard({ subscription, isLast }: Props) {
  const { t } = useTranslation();
  const { openDialog: openManageYourPlanDialog } = useManageYourPlanDialog();

  return (
    <div
      className={clsx('subscription-card', {
        'subscription-card_last': isLast,
      })}
    >
      <EquipmentInfo equipment={dummyEquipmentData[0]} />
      <div className="subscription-card__columns">
        <span className="subscription-card__label">
          {t('subscriptions.manage_plans.table.columns.plan')}
        </span>

        <span className="subscription-card__label">
          {t('subscriptions.manage_plans.table.columns.payment_type')}
        </span>

        <span className="subscription-card__label">
          {t('subscriptions.manage_plans.table.columns.renews_ends_on')}
        </span>

        <SubscriptionPlanBadge value={subscription.plan} />

        <span>
          {subscription.paymentType
            ? t(
                `subscriptions.manage_plans.table.rows.payment_type.${subscription.paymentType}`,
              )
            : ''}
        </span>

        <span className="subscription-card__due">{subscription.due}</span>
      </div>

      {subscription?.plan === 'premium' ? (
        <BaseButton
          className="subscription-card__manage-button"
          onClick={() => openManageYourPlanDialog({ equipment: {} as any })}
        >
          {t('subscriptions.manage_plans.table.rows.manage')}
        </BaseButton>
      ) : (
        <Button
          themeColor="primary"
          className="manage-subscription-plans-page__actions-cell"
          onClick={() => openManageYourPlanDialog({ equipment: {} as any })}
        >
          {t('subscriptions.manage_plans.table.rows.upgrade')}
        </Button>
      )}
    </div>
  );
}
